export const blockIconsMapsLocalLibraryNew = (
	<span className='material-symbols-outlined'>local_library</span>
);
